import React from "react";
import UserTableRow from "./UserTableRow";

export default function UserTable({
  data,
  handleUserEdit,
  handleSingleDelete,
}) {
  return (
    <div className="flex flex-col">
      <div className="overflow-auto">
        <div className="p-1.5 w-full inline-block align-middle font-medium">
          <div className="custom-scroll-container overflow-auto max-h-[70vh] border rounded-lg">
            <table className="min-w-full divide-y divide-gray-200 overflow-x-scroll">
              <thead className="bg-gray-50 sticky top-0">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-sm font-bold text-left text-gray-500 uppercase "
                  >
                    No.
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-sm font-bold text-left text-gray-500 uppercase "
                  >
                    Name
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-sm font-bold text-left text-gray-500 uppercase "
                  >
                    Email
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-sm font-bold text-left text-gray-500 uppercase "
                  >
                    role
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-sm font-bold text-left text-gray-500 uppercase "
                  >
                    status
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-sm font-bold text-left text-gray-500 uppercase "
                  >
                    updated date
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-sm font-bold text-left text-gray-500 uppercase "
                  >
                    Created date
                  </th>
                  <th
                    scope="col"
                    className="pr-7 md:pr-12 px-6 py-3 text-sm font-bold text-right text-gray-500 uppercase "
                  >
                    Edit
                  </th>
                  <th
                    scope="col"
                    className="pr-7 md:pr-12 px-6 py-3 text-sm font-bold text-right text-gray-500 uppercase "
                  >
                    Delete
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 font-medium">
                {data?.map((item, idx) => (
                  <UserTableRow
                    key={item._id}
                    no={idx + 1}
                    item={item}
                    handleUserEdit={handleUserEdit}
                    handleSingleDelete={handleSingleDelete}
                  />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
